// extracted by mini-css-extract-plugin
export default {"left":"akTN5n","external":"bkTN5n","center":"ckTN5n","right":"dkTN5n"};